import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { getAvailableLanguages, changeLanguage } from "../../../../i18n";

const LanguageSelect = ({ showLanguageSelect }) => {
  const { t, i18n } = useTranslation();
  const [selectedLang, setSelectedLang] = useState(i18n.language || "ko");
  const [isLoading, setIsLoading] = useState(false);

  const languages = getAvailableLanguages();

  const handleLanguageChange = (langCode) => {
    setIsLoading(true);
    try {
      setSelectedLang(langCode);
      changeLanguage(langCode);
      window.location.reload();
    } catch (error) {
      console.error("Failed to change language:", error);
      setIsLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={showLanguageSelect}
    >
      <div
        className="bg-[#FAFBFC] rounded-2xl shadow-[0_4px_16px_rgba(0,0,0,0.15)] w-[440px] max-h-[80vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-5 border-b border-[#E5E6E7]">
          <span className="text-lg font-bold text-[#020A1B]">{t('Admin_LangSelect_title', '언어 선택')}</span>
          <span
            className="material-icons text-[#676C76] cursor-pointer hover:text-[#020A1B]"
            onClick={showLanguageSelect}
          >
            close
          </span>
        </div>

        {/* Description */}
        <div className="px-6 pt-4 pb-2">
          <p className="text-sm text-[#676C76]">
            {t('Admin_LangSelect_description', '원하는 언어를 선택하세요. 선택한 언어로 사이트가 표시됩니다.')}
          </p>
        </div>

        {/* Language List */}
        <div className="px-6 pb-4">
          {languages.map((lang) => (
            <div
              key={lang.code}
              className={`flex justify-between items-center py-3 px-4 mb-1 rounded-lg cursor-pointer border ${
                selectedLang === lang.code
                  ? "bg-[#F2F6FC] border-[#1B5EDC]"
                  : "border-[#E5E6E7] hover:bg-[#F1F2F3]"
              }`}
              onClick={() => !isLoading && handleLanguageChange(lang.code)}
            >
              <div className="flex flex-col">
                <span className="font-medium text-[#020A1B]">{lang.name}</span>
                <span className="text-sm text-[#676C76]">
                  {lang.nativeName}
                </span>
              </div>
              {selectedLang === lang.code && (
                <svg
                  className="w-5 h-5 text-[#1B5EDC]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              )}
            </div>
          ))}
        </div>
      </div>

      {isLoading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]">
          <div className="bg-white rounded-lg p-6 text-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#1B5EDC] mx-auto mb-3"></div>
            <p>{t('Admin_LangSelect_loading', '언어를 변경하는 중...')}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSelect;
